import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="password-form"
export default class extends Controller {
  static targets = ['newPassword', 'confirmPassword', 'submitButton', 'errorMessage']

  static values = {
    lengthError: String,
    validationError: String,
    notMatch: String
  }

  connect() {
    this.submitButtonTarget.disabled = true
    
    this.newPasswordTarget.addEventListener('input', () => this.validatePassword())
    this.confirmPasswordTarget.addEventListener('input', () => this.validatePassword())
  }

  validatePassword() {
    const newPassword = this.newPasswordTarget.value
    const confirmPassword = this.confirmPasswordTarget.value
    let errors = []

    // Check minimum length
    if (newPassword.length < 8) {
      errors.push(this.lengthErrorValue)
    }

    // Check for letter, number, and special character
    const passwordFormat = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^\w\s]).{8,}$/
    if (!passwordFormat.test(newPassword)) {
      errors.push(this.validationErrorValue)
    }

    // Check if passwords match
    if (newPassword !== confirmPassword) {
      errors.push(this.notMatchValue)
    }

    // Update UI
    if (errors.length > 0) {
      this.errorMessageTarget.textContent = errors.join('. ')
      this.errorMessageTarget.classList.remove('hidden')
      this.submitButtonTarget.disabled = true
    } else {
      this.errorMessageTarget.textContent = ''
      this.errorMessageTarget.classList.add('hidden')
      this.submitButtonTarget.disabled = false
    }
  }
}
